import { FinanceProfileCreditGatewayEnum } from "./finance-profile.type"

export enum CreditOrderStatusEnum {
  pending = 'pending',
  active = 'active',
  denied = 'denied',
  paid = 'paid',
  payment_overdue = 'payment_overdue',
  cancelled = 'cancelled',
}

export interface CreditOrderProps {
  uuid: string
  debtorUuid: string
  amount: string
  paymentTerm: '15' | '30' | '45' | '60' | '90'
  orderUuid: string
  status: keyof typeof CreditOrderStatusEnum
  creditGateway?: keyof typeof FinanceProfileCreditGatewayEnum
  interest: string
  expectedPaymentDate: string
  paidAt: string
}
